import createAxiosThunk from 'store/createAxiosThunk';

import { serviceUrl as selectServiceUrl } from 'store/fusionServices/selectFusion';
import { parseArrayFilterInvalid, serviceSchema, type Service } from 'schemas';
import { axiosInstance } from '../config/selectAxios';
import { SERVICES_SLICE_NAME } from '../slicesNames';

export const fetchService = createAxiosThunk<Service, void>(
  `${SERVICES_SLICE_NAME}/fetchCurrent`,
  async (_args, thunkApi) => {
    const { getState } = thunkApi;

    const state = getState();
    const axios = axiosInstance(state);

    // get service url
    const url = selectServiceUrl(state);
    const response = await axios.get<unknown>(url);

    const service = serviceSchema.parse(response.data);

    return service;
  }
);

export const fetchServices = createAxiosThunk<Service[], { networkSlug: string }>(
  `${SERVICES_SLICE_NAME}/fetchServices`,
  async (args, thunkApi) => {
    const { getState } = thunkApi;
    const { networkSlug } = args;
    const state = getState();
    const axios = axiosInstance(state);

    const response = await axios.get<unknown>(`/service/?network_slug=${networkSlug}`);

    const services = parseArrayFilterInvalid<Service>(serviceSchema, response.data);

    return services;
  }
);
